import { ITableRequestParams } from '@Types/Table';
import { apiSlice } from './apiSlice';
import { IGenericListModel } from '@Types/GenericListModel';
import { ISession } from '@Types/Sessions';

// Add these types to your existing file
interface MonthlyTransactionCountModel {
  month: number;
  monthName: string;
  shortMonthName: string;
  transactionCount: number;
  usersCount:number;
  year: number;
}

interface MonthlyTransactionResponseModel {
  monthlyData: MonthlyTransactionCountModel[];
  totalTransactions: number;
  totalUsers:number;
  currentYear: number;
  message: string;
}

const sessionsSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    sessions: builder.query<IGenericListModel<ISession>, ITableRequestParams>({
      query: ({ sortFields, search, pageSize, currentPage, getAllPages }) => ({
        url: '/api/Sessions/GetAll',
        method: 'POST',
        body: {
          sortFields,
          search,
          pageSize,
          currentPage,
          getAllPages,
        },
      }),
      keepUnusedDataFor: 0,
      providesTags: ['sessions'] as any,
    }),
    
    sessionsBySelectedId: builder.mutation<ISession[], string[]>({
      query: (data) => ({
        url: '/api/Sessions/GetSessionsById',
        method: 'POST',
        body: data,
      }),
    }),

    // Add monthly transactions endpoint
    monthlyTransactions: builder.query<MonthlyTransactionResponseModel, number>({
      query: (year) => ({
        url: `/api/Sessions/GetMonthlyTransactionsByYear?year=${year}`,
        method: 'GET',
      }),
      providesTags: ['monthly-transactions'] as any,
    }),

    reportToDms: builder.mutation<void, string>({
      query: (id) => ({
        url: `/api/Sessions/SendToDms?id=${id}`,
        method: 'GET',
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useSessionsQuery,
  useLazySessionsQuery,
  useSessionsBySelectedIdMutation,
  useMonthlyTransactionsQuery, // Add this export
  useReportToDmsMutation,
} = sessionsSlice;

// Export types for use in components
export type { MonthlyTransactionCountModel, MonthlyTransactionResponseModel };